module.exports = __webpack_public_path__ + "img/car-duotone.5f504894.svg";